/** Supported HTML 5 Elements
    @readonly
    @enum {string}
*/
export var HTMLELEMENT;
(function (HTMLELEMENT) {
    HTMLELEMENT["DEFAULT"] = "DIV";
    HTMLELEMENT["A"] = "A";
    HTMLELEMENT["ANIMATETRANSFORM"] = "ANIMATETRANSFORM";
    HTMLELEMENT["ARTICLE"] = "ARTICLE";
    HTMLELEMENT["ASIDE"] = "ASIDE";
    HTMLELEMENT["BLOCKQUOTE"] = "BLOCKQUOTE";
    HTMLELEMENT["BODY"] = "BODY";
    HTMLELEMENT["BUTTON"] = "BUTTON";
    HTMLELEMENT["CANVAS"] = "CANVAS";
    HTMLELEMENT["CITE"] = "CITE";
    HTMLELEMENT["CODE"] = "CODE";
    HTMLELEMENT["DATALIST"] = "DATALIST";
    HTMLELEMENT["DD"] = "DD";
    HTMLELEMENT["DIALOG"] = "DIALOG";
    HTMLELEMENT["DIV"] = "DIV";
    HTMLELEMENT["DL"] = "DL";
    HTMLELEMENT["FOOTER"] = "FOOTER";
    HTMLELEMENT["FORM"] = "FORM";
    HTMLELEMENT["FIELDSET"] = "FIELDSET";
    HTMLELEMENT["I"] = "I";
    HTMLELEMENT["IFRAME"] = "IFRAME";
    HTMLELEMENT["INPUT"] = "INPUT";
    HTMLELEMENT["HEADER"] = "HEADER";
    HTMLELEMENT["H1"] = "H1";
    HTMLELEMENT["H2"] = "H2";
    HTMLELEMENT["H3"] = "H3";
    HTMLELEMENT["H4"] = "H4";
    HTMLELEMENT["H5"] = "H5";
    HTMLELEMENT["H6"] = "H6";
    HTMLELEMENT["HR"] = "HR";
    HTMLELEMENT["IMG"] = "IMG";
    HTMLELEMENT["LABEL"] = "LABEL";
    HTMLELEMENT["LEGEND"] = "LEGEND";
    HTMLELEMENT["LI"] = "LI";
    HTMLELEMENT["LIST"] = "LIST";
    HTMLELEMENT["MAIN"] = "MAIN";
    HTMLELEMENT["METER"] = "METER";
    HTMLELEMENT["MENU"] = "MENU";
    HTMLELEMENT["NAV"] = "NAV";
    HTMLELEMENT["OL"] = "OL";
    HTMLELEMENT["OPTION"] = "OPTION";
    HTMLELEMENT["OPTGROUP"] = "OPTGROUP";
    HTMLELEMENT["P"] = "P";
    HTMLELEMENT["PATH"] = "PATH";
    HTMLELEMENT["PRE"] = "PRE";
    HTMLELEMENT["PROGRESS"] = "PROGRESS";
    HTMLELEMENT["SELECT"] = "SELECT";
    HTMLELEMENT["STRONG"] = "STRONG";
    HTMLELEMENT["SPAN"] = "SPAN";
    HTMLELEMENT["SECTION"] = "SECTION";
    HTMLELEMENT["SVG"] = "SVG";
    HTMLELEMENT["TABLE"] = "TABLE";
    HTMLELEMENT["TBODY"] = "TBODY";
    HTMLELEMENT["TD"] = "TD";
    HTMLELEMENT["TFOOT"] = "TFOOT";
    HTMLELEMENT["THEAD"] = "THEAD";
    HTMLELEMENT["TEXTAREA"] = "TEXTAREA";
    HTMLELEMENT["TH"] = "TH";
    HTMLELEMENT["TR"] = "TR";
    HTMLELEMENT["UL"] = "UL";
})(HTMLELEMENT || (HTMLELEMENT = {}));
;
